export default function PHP_dechex() {
  return (
    <div>
      <h1>PHP_dechex</h1>
    </div>
  );
}
